import React from 'react';
import { FiPhone, FiMessageSquare, FiImage, FiSend, FiMail, FiVideo, FiFile, FiBell, FiPhoneCall, FiSettings, FiExternalLink, FiChevronDown } from 'react-icons/fi';

export const TYPE_META = {
  sms: { label: 'SMS', icon: <FiPhone />, color: '#7ea52e', bg: '#f4f8ee', gradient: 'linear-gradient(135deg, #7ea52e 0%, #5c7a1f 100%)' },
  whatsapp: { label: 'WhatsApp', icon: <FiMessageSquare />, color: '#22c55e', bg: '#f0fdf4', gradient: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)' },
  whatsapp_image: { label: 'WhatsApp Image', icon: <FiImage />, color: '#0891b2', bg: '#ecfeff', gradient: 'linear-gradient(135deg, #0891b2 0%, #0e7490 100%)' },
  whatsapp_video: { label: 'WhatsApp Video', icon: <FiVideo />, color: '#0d9488', bg: '#f0fdfa', gradient: 'linear-gradient(135deg, #0d9488 0%, #0f766e 100%)' },
  whatsapp_document: { label: 'WhatsApp Document', icon: <FiFile />, color: '#059669', bg: '#ecfdf5', gradient: 'linear-gradient(135deg, #059669 0%, #047857 100%)' },
  rcs: { label: 'RCS', icon: <FiMessageSquare />, color: '#7c3aed', bg: '#f5f3ff', gradient: 'linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)' },
  status_messaging: { label: 'Status Message', icon: <FiSend />, color: '#f97316', bg: '#fff7ed', gradient: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)' },
  newsletter: { label: 'Newsletter', icon: <FiMail />, color: '#ef4444', bg: '#fef2f2', gradient: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)' },
  push_notification: { label: 'Push Notification', icon: <FiBell />, color: '#1a1a18', bg: '#f4f4f2', gradient: 'linear-gradient(135deg, #1a1a18 0%, #2d2d28 100%)' },
  voice_call: { label: 'Voice Call', icon: <FiPhoneCall />, color: '#14b8a6', bg: '#f0fdfa', gradient: 'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)' },
  custom: { label: 'Custom', icon: <FiSettings />, color: '#64748b', bg: '#f1f5f9', gradient: 'linear-gradient(135deg, #64748b 0%, #475569 100%)' }
};

/* ── Shared Phone Shell ── */
const PhoneShell = ({ variant, children, width = 360 }) => (
  <div style={{ display: 'flex', justifyContent: 'center' }}>
    <div style={{
      width, background: variant === 'dark' ? '#0f0f1a' : '#fff',
      borderRadius: 32, padding: '6px 8px',
      boxShadow: '0 20px 60px rgba(0,0,0,0.25), 0 0 0 1px rgba(255,255,255,0.1) inset',
      border: variant === 'dark' ? '2px solid #2a2a3a' : '2px solid #d1d5db',
      position: 'relative', overflow: 'hidden',
    }}>
      {/* Notch */}
      <div style={{ width: 100, height: 20, background: variant === 'dark' ? '#0f0f1a' : '#fff', borderRadius: '0 0 14px 14px', margin: '-6px auto 0', position: 'relative', zIndex: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
        <div style={{ width: 6, height: 6, borderRadius: '50%', background: variant === 'dark' ? '#1a1a2e' : '#e5e7eb' }} />
        <div style={{ width: 40, height: 3, borderRadius: 2, background: variant === 'dark' ? '#1a1a2e' : '#e5e7eb' }} />
      </div>
      <div style={{ borderRadius: 24, overflow: 'hidden', marginTop: -2 }}>
        {children}
      </div>
      {/* Home indicator */}
      <div style={{ width: 80, height: 3, borderRadius: 2, background: variant === 'dark' ? 'rgba(255,255,255,0.15)' : '#d1d5db', margin: '5px auto 3px' }} />
    </div>
  </div>
);

export default function MessageTemplatePreview({ type, sched, campaignName }) {
  const meta = TYPE_META[type] || TYPE_META.sms;
  const time = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  const today = new Date().toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });

  // ─── SMS ───
  if (type === 'sms') {
    return (
      <PhoneShell variant="dark" width={360}>
        {/* Status bar */}
        <div style={{ background: '#1a1a2e', padding: '8px 16px 4px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: 11, color: '#fff', fontWeight: 600 }}>{time}</span>
          <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
            <div style={{ display: 'flex', gap: 1 }}>{[3,5,7,10].map((h,i)=><div key={i} style={{ width: 3, height: h, background: '#fff', borderRadius: 1, opacity: i < 3 ? 1 : 0.3 }}/>)}</div>
            <span style={{ fontSize: 9, color: '#fff', marginLeft: 4 }}>100%</span>
          </div>
        </div>
        {/* App header */}
        <div style={{ background: '#1a1a2e', padding: '6px 16px 12px', textAlign: 'center' }}>
          <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.4)', letterSpacing: 1, fontWeight: 600, textTransform: 'uppercase' }}>Messages</div>
          <div style={{ fontSize: 16, fontWeight: 700, color: '#fff', marginTop: 2 }}>{campaignName || sched.senderId || 'SENDER'}</div>
          <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.3)', marginTop: 2 }}>{today}</div>
        </div>
        {/* Messages area */}
        <div style={{ background: '#f2f2f7', padding: '12px 14px', minHeight: 100 }}>
          <div style={{
            background: '#e5e5ea', borderRadius: '20px 20px 20px 6px',
            padding: '12px 16px', maxWidth: '85%',
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
          }}>
            <div style={{ fontSize: 15, color: '#000', lineHeight: 1.6, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
              {sched.messageContent || 'Message...'}
            </div>
          </div>
          {sched.footerText && (
            <div style={{ fontSize: 11, color: '#8e8e93', marginTop: 6, marginLeft: 6 }}>{sched.footerText}</div>
          )}
          <div style={{ fontSize: 10, color: '#8e8e93', textAlign: 'right', marginTop: 10 }}>{time}</div>
        </div>
        {/* Input bar */}
        <div style={{ background: '#f2f2f7', padding: '0 14px 12px', display: 'flex', gap: 8, alignItems: 'center' }}>
          <div style={{ flex: 1, background: '#fff', borderRadius: 20, padding: '8px 14px', fontSize: 13, color: '#c7c7cc', border: '1px solid #e5e5ea' }}>iMessage</div>
          <div style={{ width: 32, height: 32, borderRadius: '50%', background: '#7ea52e', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <FiSend style={{ color: '#fff', fontSize: 14, transform: 'rotate(-30deg)' }} />
          </div>
        </div>
      </PhoneShell>
    );
  }

  // ─── WhatsApp / WhatsApp Image ───
  if (type === 'whatsapp' || type === 'whatsapp_image') {
    return (
      <PhoneShell variant="light" width={370}>
        {/* WhatsApp header */}
        <div style={{ background: '#075E54', padding: '10px 12px', display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ fontSize: 18, color: '#fff', cursor: 'pointer' }}>‹</div>
          <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 800, fontSize: 15, boxShadow: '0 2px 8px rgba(0,0,0,0.2)' }}>
            {(campaignName || sched.senderId || 'W')[0].toUpperCase()}
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ color: '#fff', fontSize: 15, fontWeight: 600 }}>{campaignName || 'WhatsApp Business'}</div>
            <div style={{ color: '#a8d8c8', fontSize: 11, fontWeight: 500 }}>online</div>
          </div>
          <div style={{ display: 'flex', gap: 16, color: '#fff', fontSize: 16 }}>📞 ⋮</div>
        </div>
        {/* Chat area */}
        <div style={{
          background: '#e5ddd5',
          backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'6\' height=\'6\' viewBox=\'0 0 6 6\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'%23c9c2b5\' fill-opacity=\'0.15\'%3E%3Cpath d=\'M5 0h1L0 6V5zM6 5v1H5z\'/%3E%3C/g%3E%3C/svg%3E")',
          padding: '10px 12px', minHeight: 120,
        }}>
          <div style={{ textAlign: 'center', marginBottom: 8 }}>
            <span style={{ fontSize: 10, color: '#667', background: '#e1f3d6', borderRadius: 6, padding: '3px 12px', fontWeight: 600, boxShadow: '0 1px 2px rgba(0,0,0,0.06)' }}>TODAY</span>
          </div>
          <div style={{
            background: '#dcf8c6', borderRadius: '2px 12px 12px 12px',
            maxWidth: '88%', overflow: 'hidden',
            boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
          }}>
            {sched.headerText && (
              <div style={{ padding: '10px 14px 4px', fontSize: 14, fontWeight: 700, color: '#111' }}>{sched.headerText}</div>
            )}
            {type === 'whatsapp_image' && (
              <div style={{ background: '#c8e6c9', margin: '6px 6px 0', borderRadius: 8, overflow: 'hidden', height: 180 }}>
                {sched.imageUrl ? (
                  <img src={sched.imageUrl} alt="" style={{ width: '100%', height: 180, objectFit: 'cover' }}
                    onError={e => { e.target.parentElement.innerHTML = '<div style="height:180px;display:flex;align-items:center;justify-content:center;color:#69a36f;font-size:42px">🖼️</div>'; }} />
                ) : <div style={{ height: 180, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><FiImage style={{ fontSize: 42, color: '#69a36f' }} /></div>}
              </div>
            )}
            <div style={{ padding: '10px 14px', fontSize: 15, color: '#111', lineHeight: 1.6, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
              {sched.messageContent || 'Message...'}
            </div>
            {sched.footerText && <div style={{ padding: '0 14px 6px', fontSize: 11, color: '#8a8a8a' }}>{sched.footerText}</div>}
            <div style={{ padding: '0 14px 8px', textAlign: 'right', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 4 }}>
              <span style={{ fontSize: 10, color: '#7d9b7e' }}>{time}</span>
              <span style={{ fontSize: 11, color: '#4fc3f7' }}>✓✓</span>
            </div>
            {sched.buttonText && (
              <div style={{ borderTop: '1px solid #b6dab8', padding: '12px 14px', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                <FiExternalLink style={{ fontSize: 13, color: '#039be5' }} />
                <span style={{ color: '#039be5', fontSize: 14, fontWeight: 600 }}>{sched.buttonText}</span>
              </div>
            )}
          </div>
          {sched.templateName && <div style={{ fontSize: 10, color: '#777', marginTop: 8, textAlign: 'center', fontStyle: 'italic' }}>Template: {sched.templateName}</div>}
        </div>
        {/* Input bar */}
        <div style={{ background: '#f0f0f0', padding: '8px 10px', display: 'flex', gap: 8, alignItems: 'center' }}>
          <span style={{ fontSize: 18 }}>😊</span>
          <div style={{ flex: 1, background: '#fff', borderRadius: 20, padding: '8px 14px', fontSize: 13, color: '#999' }}>Type a message</div>
          <div style={{ width: 36, height: 36, borderRadius: '50%', background: '#075E54', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span style={{ fontSize: 16 }}>🎤</span>
          </div>
        </div>
      </PhoneShell>
    );
  }

  // ─── Status Messaging ───
  if (type === 'status_messaging') {
    return (
      <PhoneShell variant="light" width={370}>
        <div style={{ background: meta.gradient, padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ width: 40, height: 40, borderRadius: '50%', background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <FiSend style={{ color: '#fff', fontSize: 18 }} />
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ color: '#fff', fontSize: 15, fontWeight: 700 }}>{campaignName || sched.senderId || 'STATUS'}</div>
            <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 11, fontWeight: 500 }}>Transactional Message</div>
          </div>
          <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.5)' }}>{time}</div>
        </div>
        <div style={{ padding: 14, background: '#fff', minHeight: 100 }}>
          {sched.templateName && (
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: '#fff7ed', padding: '5px 12px', borderRadius: 6, marginBottom: 14, border: '1px solid #fed7aa' }}>
              <FiFile style={{ fontSize: 12, color: '#ea580c' }} />
              <span style={{ fontSize: 11, color: '#bf360c', fontWeight: 600 }}>Template: {sched.templateName}</span>
            </div>
          )}
          <div style={{
            fontSize: 15, color: '#333', lineHeight: 1.7, whiteSpace: 'pre-wrap',
            background: '#fafafa', borderRadius: 12, padding: 16,
            border: '1px solid #f0f0f0', wordBreak: 'break-word',
          }}>
            {sched.messageContent || 'Status message...'}
          </div>
          {sched.footerText && <div style={{ fontSize: 12, color: '#999', marginTop: 12, textAlign: 'center' }}>{sched.footerText}</div>}
        </div>
      </PhoneShell>
    );
  }

  // ─── Newsletter ───
  if (type === 'newsletter') {
    return (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div style={{
          width: 540, background: '#fff', borderRadius: 20, overflow: 'hidden',
          boxShadow: '0 20px 60px rgba(0,0,0,0.15), 0 0 0 1px rgba(0,0,0,0.05)',
          border: '3px solid #e5e7eb',
        }}>
          {/* Email client top bar */}
          <div style={{ background: '#fafafa', padding: '11px 16px', borderBottom: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', gap: 8 }}>
            <div style={{ display: 'flex', gap: 6 }}>
              <div style={{ width: 10, height: 10, borderRadius: '50%', background: '#ef4444', boxShadow: '0 0 0 1px rgba(0,0,0,0.06)' }} />
              <div style={{ width: 10, height: 10, borderRadius: '50%', background: '#f59e0b', boxShadow: '0 0 0 1px rgba(0,0,0,0.06)' }} />
              <div style={{ width: 10, height: 10, borderRadius: '50%', background: '#22c55e', boxShadow: '0 0 0 1px rgba(0,0,0,0.06)' }} />
            </div>
            <div style={{ flex: 1, textAlign: 'center' }}>
              <span style={{ fontSize: 12, color: '#94a3b8', fontWeight: 600 }}>
                <FiMail style={{ verticalAlign: -2, marginRight: 4 }} />Newsletter
              </span>
            </div>
          </div>

          {/* Subject */}
          {sched.subject && (
            <div style={{ padding: '16px 20px 8px' }}>
              <div style={{ fontSize: 18, fontWeight: 800, color: '#0f172a', lineHeight: 1.3, fontFamily: 'Poppins, sans-serif' }}>{sched.subject}</div>
              <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>{today}</div>
            </div>
          )}

          {/* Header banner */}
          <div style={{
            background: meta.gradient, padding: '28px 24px', margin: '8px 16px',
            borderRadius: 14, position: 'relative', overflow: 'hidden',
          }}>
            <div style={{ position: 'absolute', top: -20, right: -20, width: 80, height: 80, borderRadius: '50%', background: 'rgba(255,255,255,0.1)' }} />
            <div style={{ position: 'absolute', bottom: -10, left: -10, width: 50, height: 50, borderRadius: '50%', background: 'rgba(255,255,255,0.06)' }} />
            <div style={{ position: 'relative', zIndex: 1 }}>
              {sched.headerText && <div style={{ fontSize: 22, fontWeight: 800, color: '#fff', lineHeight: 1.3 }}>{sched.headerText}</div>}
              {!sched.headerText && sched.subject && <div style={{ fontSize: 22, fontWeight: 800, color: '#fff', lineHeight: 1.3 }}>{sched.subject}</div>}
            </div>
          </div>

          {/* Image */}
          {sched.imageUrl && (
            <div style={{ padding: '8px 16px 0' }}>
              <div style={{ borderRadius: 12, overflow: 'hidden', height: 170, background: '#f1f5f9' }}>
                <img src={sched.imageUrl} alt="" style={{ width: '100%', height: 170, objectFit: 'cover' }}
                  onError={e => { e.target.style.display = 'none'; }} />
              </div>
            </div>
          )}

          {/* Body */}
          <div style={{
            padding: '18px 24px', fontSize: 15, color: '#334155',
            lineHeight: 1.8, whiteSpace: 'pre-wrap', wordBreak: 'break-word',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          }}>
            {sched.messageContent || 'Newsletter content...'}
          </div>

          {/* CTA Button */}
          {sched.buttonText && (
            <div style={{ padding: '4px 24px 24px', textAlign: 'center' }}>
              <div style={{
                display: 'inline-flex', alignItems: 'center', gap: 8,
                background: meta.gradient, color: '#fff',
                padding: '14px 36px', borderRadius: 50,
                fontSize: 15, fontWeight: 700, letterSpacing: 0.3,
                boxShadow: '0 4px 16px rgba(239,68,68,0.3), 0 2px 4px rgba(0,0,0,0.1)',
                cursor: 'pointer',
              }}>
                {sched.buttonText}
                <FiExternalLink style={{ fontSize: 14 }} />
              </div>
              {sched.buttonUrl && <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 8 }}>{sched.buttonUrl}</div>}
            </div>
          )}

          {/* Footer */}
          <div style={{
            padding: '16px 24px', borderTop: '1px solid #f1f5f9',
            background: '#fafafa', textAlign: 'center',
          }}>
            {sched.footerText && <div style={{ fontSize: 12, color: '#94a3b8', lineHeight: 1.5 }}>{sched.footerText}</div>}
            {!sched.footerText && <div style={{ fontSize: 11, color: '#cbd5e1' }}>Sent via Digital Setu</div>}
          </div>
        </div>
      </div>
    );
  }

  // ─── WhatsApp Video ───
  if (type === 'whatsapp_video') {
    return (
      <PhoneShell variant="light" width={370}>
        <div style={{ background: '#075E54', padding: '10px 12px', display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ fontSize: 18, color: '#fff' }}>‹</div>
          <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 800, fontSize: 15 }}>
            {(campaignName || sched.senderId || 'W')[0].toUpperCase()}
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ color: '#fff', fontSize: 15, fontWeight: 600 }}>{campaignName || 'WhatsApp Business'}</div>
            <div style={{ color: '#a8d8c8', fontSize: 11 }}>online</div>
          </div>
        </div>
        <div style={{
          background: '#e5ddd5',
          backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'6\' height=\'6\' viewBox=\'0 0 6 6\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'%23c9c2b5\' fill-opacity=\'0.15\'%3E%3Cpath d=\'M5 0h1L0 6V5zM6 5v1H5z\'/%3E%3C/g%3E%3C/svg%3E")',
          padding: '10px 12px', minHeight: 120,
        }}>
          <div style={{ textAlign: 'center', marginBottom: 8 }}>
            <span style={{ fontSize: 10, color: '#667', background: '#e1f3d6', borderRadius: 6, padding: '3px 12px', fontWeight: 600 }}>TODAY</span>
          </div>
          <div style={{ background: '#dcf8c6', borderRadius: '2px 12px 12px 12px', maxWidth: '88%', overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
            {sched.headerText && <div style={{ padding: '10px 14px 4px', fontSize: 14, fontWeight: 700 }}>{sched.headerText}</div>}
            <div style={{ background: '#0a0a0a', height: 150, position: 'relative', margin: '6px 6px 0', borderRadius: 8, overflow: 'hidden' }}>
              <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ width: 56, height: 56, borderRadius: '50%', background: 'rgba(255,255,255,0.2)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', boxShadow: '0 4px 16px rgba(0,0,0,0.3)' }}>
                  <span style={{ fontSize: 28, color: '#fff', marginLeft: 4 }}>▶</span>
                </div>
              </div>
              <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '8px 10px', background: 'linear-gradient(transparent, rgba(0,0,0,0.6))', display: 'flex', alignItems: 'center', gap: 8 }}>
                <FiVideo style={{ color: '#fff', fontSize: 12 }} />
                <div style={{ flex: 1, height: 3, background: 'rgba(255,255,255,0.25)', borderRadius: 2 }}>
                  <div style={{ width: '30%', height: '100%', background: '#fff', borderRadius: 2 }} />
                </div>
                <span style={{ fontSize: 9, color: '#ccc' }}>0:30</span>
              </div>
            </div>
            <div style={{ padding: '10px 14px', fontSize: 15, color: '#111', lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>
              {sched.messageContent || 'Message...'}
            </div>
            {sched.footerText && <div style={{ padding: '0 14px 6px', fontSize: 11, color: '#8a8a8a' }}>{sched.footerText}</div>}
            <div style={{ padding: '0 14px 8px', textAlign: 'right', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 4 }}>
              <span style={{ fontSize: 10, color: '#7d9b7e' }}>{time}</span>
              <span style={{ fontSize: 11, color: '#4fc3f7' }}>✓✓</span>
            </div>
            {sched.buttonText && (
              <div style={{ borderTop: '1px solid #b6dab8', padding: '12px 14px', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                <FiExternalLink style={{ fontSize: 13, color: '#039be5' }} />
                <span style={{ color: '#039be5', fontSize: 14, fontWeight: 600 }}>{sched.buttonText}</span>
              </div>
            )}
          </div>
          {sched.templateName && <div style={{ fontSize: 10, color: '#777', marginTop: 8, textAlign: 'center', fontStyle: 'italic' }}>Template: {sched.templateName}</div>}
        </div>
        <div style={{ background: '#f0f0f0', padding: '8px 10px', display: 'flex', gap: 8, alignItems: 'center' }}>
          <span style={{ fontSize: 18 }}>😊</span>
          <div style={{ flex: 1, background: '#fff', borderRadius: 20, padding: '8px 14px', fontSize: 13, color: '#999' }}>Type a message</div>
          <div style={{ width: 36, height: 36, borderRadius: '50%', background: '#075E54', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span style={{ fontSize: 16 }}>🎤</span>
          </div>
        </div>
      </PhoneShell>
    );
  }

  // ─── WhatsApp Document ───
  if (type === 'whatsapp_document') {
    return (
      <PhoneShell variant="light" width={370}>
        <div style={{ background: '#075E54', padding: '10px 12px', display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ fontSize: 18, color: '#fff' }}>‹</div>
          <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 800, fontSize: 15 }}>
            {(campaignName || sched.senderId || 'W')[0].toUpperCase()}
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ color: '#fff', fontSize: 15, fontWeight: 600 }}>{campaignName || 'WhatsApp Business'}</div>
            <div style={{ color: '#a8d8c8', fontSize: 11 }}>online</div>
          </div>
        </div>
        <div style={{
          background: '#e5ddd5',
          backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'6\' height=\'6\' viewBox=\'0 0 6 6\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'%23c9c2b5\' fill-opacity=\'0.15\'%3E%3Cpath d=\'M5 0h1L0 6V5zM6 5v1H5z\'/%3E%3C/g%3E%3C/svg%3E")',
          padding: '10px 12px', minHeight: 120,
        }}>
          <div style={{ textAlign: 'center', marginBottom: 8 }}>
            <span style={{ fontSize: 10, color: '#667', background: '#e1f3d6', borderRadius: 6, padding: '3px 12px', fontWeight: 600 }}>TODAY</span>
          </div>
          <div style={{ background: '#dcf8c6', borderRadius: '2px 12px 12px 12px', maxWidth: '88%', overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
            {sched.headerText && <div style={{ padding: '10px 14px 4px', fontSize: 14, fontWeight: 700 }}>{sched.headerText}</div>}
            <div style={{ background: '#e8f5e9', margin: '8px 8px 0', borderRadius: 10, padding: 14, display: 'flex', alignItems: 'center', gap: 12, border: '1px solid rgba(0,0,0,0.04)' }}>
              <div style={{ width: 48, height: 56, background: '#c62828', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, boxShadow: '0 2px 8px rgba(198,40,40,0.25)' }}>
                <span style={{ color: '#fff', fontSize: 11, fontWeight: 800 }}>PDF</span>
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 14, fontWeight: 700, color: '#222', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{sched.documentName || 'Document.pdf'}</div>
                <div style={{ fontSize: 10, color: '#888', marginTop: 3 }}>1 page &bull; PDF &bull; 245 KB</div>
              </div>
              <FiChevronDown style={{ fontSize: 20, color: '#69a36f', flexShrink: 0 }} />
            </div>
            <div style={{ padding: '10px 14px', fontSize: 15, color: '#111', lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>
              {sched.messageContent || 'Message...'}
            </div>
            {sched.footerText && <div style={{ padding: '0 14px 6px', fontSize: 11, color: '#8a8a8a' }}>{sched.footerText}</div>}
            <div style={{ padding: '0 14px 8px', textAlign: 'right', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 4 }}>
              <span style={{ fontSize: 10, color: '#7d9b7e' }}>{time}</span>
              <span style={{ fontSize: 11, color: '#4fc3f7' }}>✓✓</span>
            </div>
            {sched.buttonText && (
              <div style={{ borderTop: '1px solid #b6dab8', padding: '12px 14px', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                <FiExternalLink style={{ fontSize: 13, color: '#039be5' }} />
                <span style={{ color: '#039be5', fontSize: 14, fontWeight: 600 }}>{sched.buttonText}</span>
              </div>
            )}
          </div>
          {sched.templateName && <div style={{ fontSize: 10, color: '#777', marginTop: 8, textAlign: 'center', fontStyle: 'italic' }}>Template: {sched.templateName}</div>}
        </div>
        <div style={{ background: '#f0f0f0', padding: '8px 10px', display: 'flex', gap: 8, alignItems: 'center' }}>
          <span style={{ fontSize: 18 }}>😊</span>
          <div style={{ flex: 1, background: '#fff', borderRadius: 20, padding: '8px 14px', fontSize: 13, color: '#999' }}>Type a message</div>
          <div style={{ width: 36, height: 36, borderRadius: '50%', background: '#075E54', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span style={{ fontSize: 16 }}>🎤</span>
          </div>
        </div>
      </PhoneShell>
    );
  }

  // ─── RCS ───
  if (type === 'rcs') {
    return (
      <PhoneShell variant="light" width={380}>
        <div style={{ background: meta.gradient, padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ fontSize: 18, color: '#fff' }}>‹</div>
          <div style={{ width: 38, height: 38, borderRadius: '50%', background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 800, fontSize: 15 }}>
            {(campaignName || sched.senderId || 'B')[0].toUpperCase()}
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ color: '#fff', fontSize: 15, fontWeight: 600 }}>{campaignName || sched.senderId || 'Brand'}</div>
            <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 11, fontWeight: 500 }}>Verified Business ✓</div>
          </div>
        </div>
        <div style={{ padding: 12, background: '#f8f9fa', minHeight: 100 }}>
          <div style={{
            background: '#fff', borderRadius: 16, overflow: 'hidden',
            boxShadow: '0 2px 12px rgba(0,0,0,0.06)', maxWidth: '90%',
            border: '1px solid rgba(0,0,0,0.04)',
          }}>
            {sched.imageUrl && (
              <div style={{ height: 180, background: '#e0e0e0' }}>
                <img src={sched.imageUrl} alt="" style={{ width: '100%', height: 180, objectFit: 'cover' }}
                  onError={e => { e.target.style.display = 'none'; }} />
              </div>
            )}
            {sched.headerText && <div style={{ padding: '14px 16px 6px', fontSize: 16, fontWeight: 800, color: '#0f172a' }}>{sched.headerText}</div>}
            <div style={{ padding: '10px 16px 14px', fontSize: 15, color: '#444', lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>
              {sched.messageContent || 'Rich message...'}
            </div>
            {sched.buttonText && (
              <div style={{ padding: '0 16px 16px' }}>
                <div style={{ background: meta.gradient, color: '#fff', textAlign: 'center', padding: '12px 18px', borderRadius: 50, fontSize: 14, fontWeight: 700, boxShadow: '0 4px 12px rgba(124,58,237,0.3)' }}>
                  {sched.buttonText}
                </div>
              </div>
            )}
            {sched.footerText && <div style={{ padding: '10px 16px 14px', fontSize: 11, color: '#94a3b8', borderTop: '1px solid #f1f5f9' }}>{sched.footerText}</div>}
          </div>
          <div style={{ fontSize: 10, color: '#aaa', textAlign: 'right', marginTop: 8 }}>{time}</div>
        </div>
        <div style={{ background: '#f0f0f0', padding: '8px 10px', display: 'flex', gap: 8, alignItems: 'center' }}>
          <div style={{ flex: 1, background: '#fff', borderRadius: 20, padding: '8px 14px', fontSize: 13, color: '#999' }}>Type a message</div>
          <div style={{ width: 36, height: 36, borderRadius: '50%', background: '#7c3aed', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <FiSend style={{ color: '#fff', fontSize: 14, transform: 'rotate(-30deg)' }} />
          </div>
        </div>
      </PhoneShell>
    );
  }

  // ─── Push Notification ───
  if (type === 'push_notification') {
    return (
      <PhoneShell variant="dark" width={370}>
        {/* Lock screen */}
        <div style={{ background: 'linear-gradient(180deg, #0f172a 0%, #1e293b 100%)', padding: '16px 14px', minHeight: 220 }}>
          <div style={{ textAlign: 'center', marginBottom: 20 }}>
            <div style={{ fontSize: 48, fontWeight: 200, color: '#fff', letterSpacing: -2 }}>{time}</div>
            <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', marginTop: 2 }}>
              {new Date().toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })}
            </div>
          </div>
          <div style={{
            background: 'rgba(255,255,255,0.08)', backdropFilter: 'blur(20px)',
            borderRadius: 18, padding: 14, display: 'flex', gap: 12, alignItems: 'flex-start',
            border: '1px solid rgba(255,255,255,0.06)',
            boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
          }}>
            <div style={{
              width: 42, height: 42, borderRadius: 12, background: meta.gradient,
              display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
              boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
            }}>
              <FiBell style={{ color: '#fff', fontSize: 18 }} />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                <span style={{ fontSize: 12, fontWeight: 700, color: 'rgba(255,255,255,0.9)', textTransform: 'uppercase', letterSpacing: 0.5 }}>{campaignName || sched.senderId || 'APP NAME'}</span>
                <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.35)' }}>now</span>
              </div>
              <div style={{ fontSize: 15, fontWeight: 600, color: '#eee', marginBottom: 4, lineHeight: 1.3 }}>{sched.notificationTitle || 'Notification Title'}</div>
              <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.6)', lineHeight: 1.5, display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                {sched.messageContent || 'Notification body...'}
              </div>
              {sched.imageUrl && (
                <div style={{ marginTop: 10, height: 120, borderRadius: 12, overflow: 'hidden', background: '#1e293b' }}>
                  <img src={sched.imageUrl} alt="" style={{ width: '100%', height: 120, objectFit: 'cover' }} onError={e => { e.target.style.display = 'none'; }} />
                </div>
              )}
              {sched.buttonText && (
                <div style={{ marginTop: 10, display: 'flex', gap: 10 }}>
                  <span style={{ fontSize: 13, color: '#60a5fa', fontWeight: 600, background: 'rgba(96,165,250,0.1)', padding: '6px 16px', borderRadius: 10 }}>{sched.buttonText}</span>
                  <span style={{ fontSize: 13, color: 'rgba(255,255,255,0.35)', padding: '6px 16px' }}>Dismiss</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </PhoneShell>
    );
  }

  // ─── Voice Call ───
  if (type === 'voice_call') {
    return (
      <PhoneShell variant="dark" width={340}>
        <div style={{ background: 'linear-gradient(180deg, #0d2b2b 0%, #0a1a1a 100%)', padding: '20px 16px', textAlign: 'center', minHeight: 260 }}>
          <div style={{
            width: 90, height: 90, borderRadius: '50%', background: meta.gradient,
            margin: '0 auto 18px', display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 0 40px rgba(20,184,166,0.3), 0 0 0 8px rgba(20,184,166,0.1)',
          }}>
            <FiPhoneCall style={{ fontSize: 36, color: '#fff' }} />
          </div>
          <div style={{ fontSize: 22, fontWeight: 800, color: '#fff', marginBottom: 4, letterSpacing: -0.5 }}>{campaignName || sched.senderId || 'Caller ID'}</div>
          <div style={{ fontSize: 13, color: '#4ade80', marginBottom: 24, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
            <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#4ade80' }} />
            Connected &bull; 00:15
          </div>
          <div style={{
            background: 'rgba(255,255,255,0.05)', borderRadius: 16, padding: 18,
            marginBottom: 24, textAlign: 'left',
            border: '1px solid rgba(255,255,255,0.06)',
          }}>
            <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.4)', marginBottom: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 2, display: 'flex', alignItems: 'center', gap: 6 }}>
              <div style={{ width: 6, height: 6, borderRadius: '50%', background: '#4ade80' }} />
              Voice Script (TTS)
            </div>
            <div style={{ fontSize: 15, color: '#e2e8f0', lineHeight: 1.8, whiteSpace: 'pre-wrap', fontStyle: 'italic' }}>
              "{sched.voiceScript || sched.messageContent || 'Hello, this is an automated call...'}"
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', gap: 28 }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ width: 56, height: 56, borderRadius: '50%', background: '#ef4444', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 8px', boxShadow: '0 4px 16px rgba(239,68,68,0.4)' }}>
                <span style={{ color: '#fff', fontSize: 22 }}>✕</span>
              </div>
              <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.4)' }}>End</span>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ width: 56, height: 56, borderRadius: '50%', background: 'rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 8px' }}>
                <span style={{ fontSize: 20 }}>🔇</span>
              </div>
              <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.4)' }}>Mute</span>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ width: 56, height: 56, borderRadius: '50%', background: 'rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 8px' }}>
                <span style={{ fontSize: 20 }}>🔊</span>
              </div>
              <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.4)' }}>Speaker</span>
            </div>
          </div>
        </div>
      </PhoneShell>
    );
  }

  // ─── Custom ───
  if (type === 'custom') {
    const fields = sched.customFields || {};
    return (
      <PhoneShell variant="light" width={380}>
        <div style={{ background: meta.gradient, padding: '16px 18px', display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ width: 40, height: 40, borderRadius: 12, background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <FiSettings style={{ fontSize: 20, color: '#fff' }} />
          </div>
          <div>
            <div style={{ fontSize: 16, fontWeight: 700, color: '#fff' }}>Custom Template</div>
            <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)' }}>{campaignName || sched.senderId || 'Custom Channel'}</div>
          </div>
        </div>
        <div style={{ padding: 14, background: '#fff', minHeight: 100 }}>
          {sched.headerText && <div style={{ fontSize: 16, fontWeight: 700, color: '#0f172a', marginBottom: 8 }}>{sched.headerText}</div>}
          {sched.messageContent && (
            <div style={{ fontSize: 15, color: '#334155', lineHeight: 1.7, whiteSpace: 'pre-wrap', marginBottom: 14 }}>
              {sched.messageContent}
            </div>
          )}
          {Object.keys(fields).length > 0 && (
            <div style={{ marginBottom: 14 }}>
              <div style={{ fontSize: 10, fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 1.5, marginBottom: 10, paddingBottom: 6, borderBottom: '2px solid #f1f5f9' }}>Custom Fields</div>
              {Object.entries(fields).map(([key, val], i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #f8fafc', fontSize: 14 }}>
                  <span style={{ color: '#64748b', fontWeight: 500 }}>{key}</span>
                  <span style={{ color: '#0f172a', fontWeight: 600, maxWidth: '55%', textAlign: 'right', wordBreak: 'break-word' }}>{val || '—'}</span>
                </div>
              ))}
            </div>
          )}
          {sched.imageUrl && (
            <div style={{ borderRadius: 12, overflow: 'hidden', height: 150, background: '#f1f5f9', marginBottom: 14 }}>
              <img src={sched.imageUrl} alt="" style={{ width: '100%', height: 150, objectFit: 'cover' }} onError={e => { e.target.style.display = 'none'; }} />
            </div>
          )}
          {sched.buttonText && (
            <div style={{ textAlign: 'center', marginBottom: 8 }}>
              <span style={{ display: 'inline-block', background: meta.gradient, color: '#fff', padding: '12px 30px', borderRadius: 50, fontSize: 14, fontWeight: 700, boxShadow: '0 4px 12px rgba(100,116,139,0.25)' }}>
                {sched.buttonText}
              </span>
            </div>
          )}
          {sched.footerText && <div style={{ padding: '12px 0 0', fontSize: 12, color: '#94a3b8', textAlign: 'center', borderTop: '1px solid #f1f5f9' }}>{sched.footerText}</div>}
        </div>
      </PhoneShell>
    );
  }

  return null;
}
